import { GraftConfig as MembershipsGraftConfig } from '@graft/nuget-gc.webportals.memberships'

import { readGraftWebserviceUrl } from '@common/core/config/utils/read-graft-webservice-url.util'

const membershipsUrl = readGraftWebserviceUrl('MEMBERSHIPS')

if (membershipsUrl) {
  MembershipsGraftConfig.host = membershipsUrl
  MembershipsGraftConfig.stateless = true
}
